<template>
  <div
    v-if="isVisible"
    class="p-point-navi"
    :style="{ '--site-color': colorCode }"
  >
    <div class="p-point-navi__bar">
      <button
        type="button"
        class="p-point-navi__button"
        @click="scrollToArea('thanks-point-area')"
      >
        <IconBase
          class="p-point-navi__icon"
          :width="32"
          :height="32"
          view-box="0 0 32 32"
          icon-name="ポイントを贈る"
        >
          <IconGivePoint icon-color="#fff" />
        </IconBase>
        <span class="p-point-navi__label p-point-navi__label--pc">
          <span data-translate-skip>{{ pointName }}</span>を贈る
        </span>
        <span class="p-point-navi__label p-point-navi__label--sp">
          贈る
        </span>
      </button>
      <button
        type="button"
        class="p-point-navi__button"
        @click="scrollToArea('product-exchange-area')"
      >
        <IconBase
          class="p-point-navi__icon"
          :width="32"
          :height="32"
          view-box="0 0 32 32"
          icon-name="商品と交換する"
        >
          <IconExchangePoint icon-color="#fff" />
        </IconBase>
        <span class="p-point-navi__label p-point-navi__label--pc">
          商品と交換する
        </span>
        <span class="p-point-navi__label p-point-navi__label--sp">
          交換する
        </span>
      </button>
      <button
        type="button"
        class="p-point-navi__button"
        @click="scrollToArea('earn-point-area')"
      >
        <IconBase
          class="p-point-navi__icon"
          :width="32"
          :height="32"
          view-box="0 0 32 32"
          icon-name="ポイントを獲得する"
        >
          <IconEarnPoint icon-color="#fff" />
        </IconBase>
        <span class="p-point-navi__label p-point-navi__label--pc">
          <span data-translate-skip>{{ pointName }}</span>を獲得する
        </span>
        <span class="p-point-navi__label p-point-navi__label--sp">
          獲得する
        </span>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { mapState } from "vuex";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconGivePoint from "@/common/components/icons/IconGivePoint.vue";
import IconExchangePoint from "@/common/components/icons/IconExchangePoint.vue";
import IconEarnPoint from "@/common/components/icons/IconEarnPoint.vue";
import commons from "@/common/store/modules/commons";

@Options({
  props: {
    grantCriteriaCount: { type: Number, required: true, default: 0 }
  },
  components: {
    IconBase,
    IconGivePoint,
    IconExchangePoint,
    IconEarnPoint
  },
  computed: {
    ...mapState({
      storeColorCode: () => commons.colorCode
    })
  }
})
export default class PointNavi extends Vue {
  grantCriteriaCount!: number;
  storeColorCode!: string;

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode;
  }

  get colorCode() {
    if (this.isGroupBudget) {
      return "#fc9014";
    }
    return this.storeColorCode;
  }

  get thanksFunctionEnabled() {
    return commons.thanksFunctionEnabled;
  }

  get pointName() {
    return commons.OrgPageSpecific?.point_name || commons?.unit?.point;
  }

  get isVisible() {
    return (
      this.thanksFunctionEnabled &&
      this.isGroupBudget === false &&
      this.grantCriteriaCount >= 1
    );
  }

  scrollToArea(areaId: string) {
    const target = document.getElementById(areaId);
    if (!target) {
      return;
    }
    const header = document.querySelector(".l-the-header") as HTMLElement | null;
    const headerHeight = header ? header.getBoundingClientRect().height : 0;
    const top =
      target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
    window.scrollTo({
      top,
      behavior: "smooth"
    });
  }
}
</script>

<style lang="scss" scoped>
.p-point-navi {
  width: 100%;
  margin-bottom: rem(16);

  &__bar {
    display: flex;
    overflow: hidden;
    width: 100%;
    background-color: $common-white;
    border-radius: rem(8);
    gap: px(2);
  }

  &__button {
    display: flex;
    flex: 1 0 0;
    gap: rem(8);
    align-items: center;
    justify-content: center;
    min-width: 0;
    height: rem(64);
    padding: rem(16);
    color: $common-white;
    background-color: var(--site-color);
    border: none;
    cursor: pointer;
  }

  &__icon {
    flex-shrink: 0;
    width: rem(32);
    height: rem(32);
  }

  &__label {
    color: inherit;
    font-family: $font--noto-sans-only;
    font-size: rem(20);
    font-weight: 700;
    line-height: 1.25;
    white-space: nowrap;
    font-feature-settings: "pwid" 1, "palt" 1;

    &--sp {
      display: none;
    }
  }

  @include large-sp {
    &__button {
      flex-direction: column;
      gap: rem(4);
      padding: rem(8) rem(16);
    }

    &__icon {
      width: rem(24);
      height: rem(24);
    }

    &__label {
      font-size: rem(16);

      &--pc {
        display: none;
      }

      &--sp {
        display: block;
      }
    }
  }
}
</style>
